import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { DynamicBG, FormForgot } from "~/components/blocks";
import { scrollTop, parentScrollTop } from "~/utils/tools";

export default function ForgotPass() {
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    scrollTop();
    parentScrollTop();
  }, []);

  return (
    <motion.div
      variants={animations}
      className="single"
      initial="exit"
      animate="enter"
      exit="exit"
    >
      <DynamicBG content>
        <FormForgot />
      </DynamicBG>
    </motion.div>
  );
}
